/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const img = `
<svg id="Group_3514" data-name="Group 3514" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <rect id="Rectangle_934" data-name="Rectangle 934" width="24" height="6" rx="3" fill="currentColor"/>
  <rect id="Rectangle_939" data-name="Rectangle 939" width="24" height="6" rx="3" transform="translate(0 18)" fill="currentColor"/>
  <rect id="Rectangle_940" data-name="Rectangle 940" width="24" height="6" rx="3" transform="translate(0 9)" fill="currentColor" />
</svg>
`
const LayoutOneColumnSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: img }} />
}

export default LayoutOneColumnSvg
